import React, { useState } from "react";
import { Row, Col, Breadcrumb, Dropdown, Button } from "react-bootstrap";
import {
  FiHome,
  FiDownload,
  FiFileText,
  FiFile,
  FiPlus,
  FiChevronUp,
} from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import InvoiceStats from "../../components/Applications/invoice/InvoiceStats";
import AddInvoices from "../../components/modals/invoices/AddInvoices";
import InvoicesList from "../../components/Applications/invoice/InvoicesList";


const InvoicesPage = () => {
     const [activeModal, setActiveModal] = useState("invoice");
     const[open,setOpen]=useState(false)
  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }}  className="page-breadcrumb mb-3">
      <Row className="align-items-center justify-content-between">
        
        {/* LEFT SIDE */}


  <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Invoices</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                        Applications
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Invoices</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
        {/* RIGHT SIDE */}
        <Col
          md={6}
          xs={12}
          className="d-flex justify-content-md-end flex-wrap align-items-center"
        >
          {/* EXPORT DROPDOWN */}
          <Dropdown className="me-2 mb-2">
            <Dropdown.Toggle className="btn-white d-flex align-items-center custom-btn">
              <FiDownload className="me-2" />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" className="p-2 custom-dropdown">
              <Dropdown.Item className="rounded-1">
                <FiFileText className="me-2" />
                Export as PDF
              </Dropdown.Item>
              <Dropdown.Item className="rounded-1">
                <FiFile className="me-2" />
                Export as Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD BUTTON */}

           <Button onClick={()=>setOpen(true)}   className="btn-primary custom-add-btn mb-2">
            <FiPlus className="me-2" />
            Add Invoice
          </Button>


          {/* COLLAPSE ICON */}
          {/* <div className="ms-2 head-icons mb-2">
            <FiChevronUp className="collapse-icon" />
          </div> */}
        </Col>
      </Row>
      <InvoiceStats/>
      <InvoicesList></InvoicesList>
      <style>
          {
               `
               .page-breadcrumb {
  background: #f8f9fb;
  padding: 16px 20px;
  border-radius: 6px;
}

/* Title */
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
}

/* Breadcrumb */
.custom-breadcrumb {
  font-size: 14px;
  color: #6b7280;
}

.custom-breadcrumb .breadcrumb-item a {
  color: #6b7280;
  text-decoration: none;
}

.custom-breadcrumb .breadcrumb-item.active {
  color: #111827;
  font-weight: 500;
}

/* Buttons */
.custom-btn {
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  color: #111827 !important;
  font-size: 14px;
  padding: 6px 14px;
}

.custom-btn:hover {
  background: #f3f4f6 !important;
}

/* Dropdown */
.custom-dropdown {
  min-width: 180px;
  border-radius: 6px;
}

.custom-dropdown .dropdown-item {
  font-size: 14px;
  padding: 8px 10px;
}

/* Add Button */
.custom-add-btn {
  background: #ff6b2c;
  border: none;
  font-size: 14px;
  padding: 6px 16px;
}

.custom-add-btn:hover {
  background: #e85d22;
}

/* Collapse Icon */
.collapse-icon {
  font-size: 18px;
  cursor: pointer;
  color: #6b7280;
}

.collapse-icon:hover {
  color: #111827;
}

/* Responsive Fix */
@media (max-width: 768px) {
  .page-breadcrumb {
    padding: 12px;
  }

  .page-title {
    font-size: 18px;
  }

  .custom-btn,
  .custom-add-btn {
    width: 100%;
    justify-content: center;
  }
}`
          }
      </style>
      <AddInvoices     show={open} onHide={()=>setOpen(false)}/>
    </div>
  );
};

export default InvoicesPage;